export const OrderStatusCssClasses = [
  '',
  'light',
  'info',
  'warning',
  'primary',
  'success',
  'dark',
  'danger',
];
export const OrderStatusTitles = [
  '',
  'Шинэ',
  'Захиалга бүртгэсэн',
  'Трак бүртгэсэн',
  'Каргонд бүртгэсэн',
  'Хүлээн авсан',
  'Агуулахад бүртгэсэн',
  'Алдагдсан',
];
export const orderStatusList = [
  { key: -1, value: 'Төлөв' },
  { key: 0, value: 'Шинэ' },
  { key: 1, value: 'Захиалга бүртгэсэн' }, //.text-info
  { key: 2, value: 'Трак бүртгэсэн' }, //.text-warning
  { key: 3, value: 'Каргонд бүртгэсэн' }, // .text-primary
  { key: 4, value: 'Хүлээн авсан' }, //.text-success
  { key: 5, value: 'Агуулахад бүртгэсэн' }, //.text-dark
  { key: 6, value: 'Алдагдсан' }, //.text-danger
];

export const BoxStatusCssClasses = [
  'info',
  'warning',
  'primary',
  'success',
  'dark',
  'danger',
];
export const BoxStatusTitles = [
  'Шинэ',
  'Трак бүртгэсэн',
  'Каргонд бүртгэсэн',
  'Хүлээн авсан',
  'Агуулахад бүртгэсэн',
  'Алдагдсан',
];
export const boxStatusList = [
  { key: 1, value: 'Шинэ' }, //.text-info
  { key: 2, value: 'Трак бүртгэсэн' }, //.text-warning
  { key: 3, value: 'Каргонд бүртгэсэн' }, // .text-primary
  { key: 4, value: 'Хүлээн авсан' }, //.text-success
  { key: 5, value: 'Агуулахад бүртгэсэн' }, //.text-dark
  { key: 6, value: 'Алдагдсан' }, //.text-danger
];

export const defaultSorted = [{ dataField: 'order_code', order: 'desc' }];
export const sizePerPageList = [
  { text: '10', value: 10 },
  { text: '20', value: 20 },
  { text: '50', value: 50 },
];
export const initialFilter = {
  filter: {
    from: '', //Date.now(),
    to: '', //"",
    searchText: '',
    websiteCode: '',
    useReward: -1,
    status: -1,
  },
  sortOrder: 'desc', // asc||desc
  sortField: 'orderCode',
  pageNumber: 1,
  pageSize: 10,
};

export const initialOrder = {
  orderCode: '',
  orderDate: new Date(new Date().getTime()).toISOString().slice(0, 10),
  orderItemCount: 0,
  websiteCode: '',
  purchaseOrderId: '',
  cargoCode: 'SHUURKHAI',
  subTotalAmount: '0.00',
  totalTaxAmount: '0.00',
  shippingAmount: '0.00',
  totalAmount: '0.00',
  useReward: -1,
  rewardAmount: '0.00',
  cardChargeAmount: '0.00',
  items: [],
  status: 0,
};
